var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oct-list"},[(_vm.title)?_c('div',{staticClass:"oct-list-subheader"},[_c('span',{staticClass:"oct-list-subheader__primary-text"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_c('ul',{staticClass:"oct-list__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }